module.exports = __webpack_public_path__ + "img/renz_banner.3db44b97.jpg";